import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Button, Stack } from 'react-bootstrap';
import dayjs from 'dayjs';
import { NotifyModalView, NotifyButtonView } from './parts/NotifySettingView';
import UserService, { UserItem } from '#/services/UserService';
import { useParams, useNavigate } from 'react-router-dom';
import { SpinnerView } from './parts/SpinnerView';
import { UserContext } from './App';

function UserInfo() {
  const ctx = useContext(UserContext);
  const [user, setUser] = useState<UserItem>();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    new UserService(ctx.userInfo!).getList({ id }).then(
      (res) => {
        setUser(res.data[0]);
      },
      (err) => {
        if (err.response && err.response.status === 401) {
          navigate(0);
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [emailSetting, setEmailSetting] = useState<boolean>(false);
  const [smsSetting, setSmsSetting] = useState<boolean>(false);

  const onNotifySubmit = (values: any) => {
    setUser({
      ...user!,
      notify: {
        ...user!.notify,
        ...values,
      },
    });
  };

  if (!user) {
    return <SpinnerView />;
  }

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <Stack direction="horizontal">
                  <span>名称</span>
                  <span>：</span>
                  <span>{user!.name}</span>
                </Stack>
                <Stack direction="horizontal">
                  <span>ユーザID</span>
                  <span>：</span>
                  <span>{user!.id}</span>
                </Stack>
                <Stack direction="horizontal">
                  <span>登録日</span>
                  <span>：</span>
                  <span>
                    {dayjs(user!.created_at).format('YYYY/MM/DD HH:mm:ss')}
                  </span>
                </Stack>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="w-50">
                <Button variant="primary" href="/payment">
                  課金設定
                </Button>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <h4>お知らせ設定</h4>
                <NotifyButtonView
                  title="メール"
                  verifierd={user.notify.email_verifier}
                  onEnable={() => setEmailSetting(true)}
                  onDisable={() => {
                    setEmailSetting(true);
                  }}
                />
                <NotifyButtonView
                  title="ＳＭＳ"
                  verifierd={user.notify.sms_verifier}
                  onEnable={() => setSmsSetting(true)}
                  onDisable={() => {
                    setSmsSetting(true);
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <NotifyModalView
        notify_id={user.id}
        notify_type="user"
        notify_kind="email"
        title="メールアドレス"
        isShow={emailSetting}
        isVerify={user.notify.email_verifier}
        onClose={() => {
          setEmailSetting(false);
        }}
        onSubmit={onNotifySubmit}
      />
      <NotifyModalView
        notify_id={user.id}
        notify_type="user"
        notify_kind="sms"
        title="電話番号"
        isShow={smsSetting}
        isVerify={user.notify.sms_verifier}
        onClose={() => {
          setSmsSetting(false);
        }}
        onSubmit={onNotifySubmit}
      />
    </>
  );
}

export default UserInfo;
